/* eslint-disable no-case-declarations */
import paymentActions from "./actions";

const {
  CREATE_PAYMENT_BEGIN,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_ERR,

  LIST_PAYMENTS_BEGIN,
  LIST_PAYMENTS_SUCCESS,
  LIST_PAYMENTS_ERR,

  UPDATE_PAYMENT_BEGIN,
  UPDATE_PAYMENT_SUCCESS,
  UPDATE_PAYMENT_ERR,

  DELETE_PAYMENT_BEGIN,
  DELETE_PAYMENT_SUCCESS,
  DELETE_PAYMENT_ERR,

  PROCESS_PAYMENT_BEGIN,
  PROCESS_PAYMENT_SUCCESS,
  PROCESS_PAYMENT_ERR,

  REFUND_PAYMENT_BEGIN,
  REFUND_PAYMENT_SUCCESS,
  REFUND_PAYMENT_ERR,

  GET_PAYMENT_DETAILS_BEGIN,
  GET_PAYMENT_DETAILS_SUCCESS,
  GET_PAYMENT_DETAILS_ERR,
} = paymentActions;

const initPaymentState = {
  loadingCreatePayment: false,
  errorCreatePayment: "",
  loadingUpdatePayment: false,
  errorUpdatePayment: "",
  payments: [],
  loadingListPayments: false,
  errorListPayments: "",
  totalPayments: 0,
  totalPaymentsPages: 0,
  loadingDeletePayment: false,
  errorDeletePayment: "",
  loadingProcessPayment: false,
  errorProcessPayment: null,
  loadingRefundPayment: false,
  errorRefundPayment: null,
  loadingGetPaymentDetails: false,
  errorGetPaymentDetails: null,
  paymentDetails: {},
  totalVAT: 0,
  totalVATByMonth: [],
};

const paymentsReducer = (state = initPaymentState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_PAYMENT_BEGIN:
      return {
        ...state,
        loadingCreatePayment: true,
        errorCreatePayment: "",
      };
    case CREATE_PAYMENT_SUCCESS:
      return {
        ...state,
        payments: [...state.payments, data],
        loadingCreatePayment: false,
        errorCreatePayment: "",
      };
    case CREATE_PAYMENT_ERR:
      return {
        ...state,
        errorCreatePayment: err,
        loadingCreatePayment: false,
      };

    case LIST_PAYMENTS_BEGIN:
      return {
        ...state,
        loadingListPayments: true,
        errorListPayments: false,
        totalPayments: 0,
        totalPaymentsPages: 0,
        totalVAT: 0,
        totalVATByMonth: [],
      };
    case LIST_PAYMENTS_SUCCESS:
      return {
        ...state,
        payments: [...data.results],
        loadingListPayments: false,
        errorListPayments: null,
        totalPayments: data.total_count,
        totalPaymentsPages: data.total_pages,
        totalVAT: data.total_vat,
        totalVATByMonth: data.total_vat_by_month,
      };
    case LIST_PAYMENTS_ERR:
      return {
        ...state,
        errorListPayments: err,
        loadingListPayments: false,
        totalPayments: 0,
        totalPaymentsPages: 0,
        totalVAT: 0,
        totalVATByMonth: [],
      };

    case UPDATE_PAYMENT_BEGIN:
      return {
        ...state,
        loadingUpdatePayment: true,
        errorUpdatePayment: false,
      };
    case UPDATE_PAYMENT_SUCCESS:
      const updatedPayments = state.payments.map((payment) =>
        payment.id === data.id ? { ...payment, ...data } : payment
      );
      return {
        ...state,
        payments: updatedPayments,
        loadingUpdatePayment: false,
        errorUpdatePayment: null,
      };
    case UPDATE_PAYMENT_ERR:
      return {
        ...state,
        errorUpdatePayment: err,
        loadingUpdatePayment: false,
      };

    case DELETE_PAYMENT_BEGIN:
      return {
        ...state,
        loadingDeletePayment: true,
        errorDeletePayment: null,
      };
    case DELETE_PAYMENT_SUCCESS:
      return {
        ...state,
        payments: state.payments.filter((payment) => payment.id !== data.id),
        loadingDeletePayment: false,
        errorDeletePayment: null,
      };
    case DELETE_PAYMENT_ERR:
      return {
        ...state,
        errorDeletePayment: err,
        loadingDeletePayment: false,
      };

    case PROCESS_PAYMENT_BEGIN:
      return {
        ...state,
        loadingProcessPayment: true,
        errorProcessPayment: null,
      };
    case PROCESS_PAYMENT_SUCCESS:
      return {
        ...state,
        loadingProcessPayment: false,
        errorProcessPayment: null,
      };
    case PROCESS_PAYMENT_ERR:
      return {
        ...state,
        loadingProcessPayment: false,
        errorProcessPayment: err,
      };

    case REFUND_PAYMENT_BEGIN:
      return {
        ...state,
        loadingRefundPayment: true,
        errorRefundPayment: null,
      };
    case REFUND_PAYMENT_SUCCESS:
      return {
        ...state,
        loadingRefundPayment: false,
        errorRefundPayment: null,
      };
    case REFUND_PAYMENT_ERR:
      return {
        ...state,
        loadingRefundPayment: false,
        errorRefundPayment: err,
      };

    case GET_PAYMENT_DETAILS_BEGIN:
      return {
        ...state,
        paymentDetails: {},
        loadingGetPaymentDetails: true,
        errorGetPaymentDetails: null,
      };
    case GET_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        paymentDetails: data,
        loadingGetPaymentDetails: false,
        errorGetPaymentDetails: null,
      };
    case GET_PAYMENT_DETAILS_ERR:
      return {
        ...state,
        paymentDetails: {},
        loadingGetPaymentDetails: false,
        errorGetPaymentDetails: err,
      };

    default:
      return state;
  }
};

export { paymentsReducer };
